var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"beba9e810f17b97536091321405d58c7d065c190"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-web@treefort-systems"]={id:"beba9e810f17b97536091321405d58c7d065c190"};
      